<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      mode="vertical"
      background-color="#273142"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      class="el-menu__custom"
    >
      <div v-if="!isCollapse" class="logo-max">
        <img src="@/assets/logo.png">
      </div>
<!--      <sidebar-item v-for="route in permission_routers" :key="route.path" :item="route" :base-path="route.path"/>-->
    </el-menu>
  </el-scrollbar>
</template>
<script>
import {mapGetters} from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: {SidebarItem},
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  mounted() {
  },
  data() {
    return {
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.logo-max {
  cursor: pointer;
  padding: 31px 36px 19px 28px;

  img {
    width: 128px;
    height: 34px;
  }
}

.logo-min {
  cursor: pointer;
  padding: 31px 0px 19px 6px;

  img {
    width: 22px;
    height: 34px;
  }
}

.el-menu__custom {
  width: 188px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue